import React from 'react';
import { PrimaryButton, TertiaryButton } from 'styleguide/Buttons';
import { Card } from 'styleguide/Card';
import { FormInput } from 'styleguide/Inputs';
import { P1, P2 } from 'styleguide/Texts';
import { View } from 'styleguide/View';
import { t } from 'translations/t';

interface Props {
  isEnabled: boolean;
  isLoading: boolean;
  onUpdateEmail: (value: string) => void;
  onSendPasswordRecovery: () => void;
  onBackToLogin: () => void;
}

export const ForgotPasswordCard = ({
  isEnabled,
  isLoading,
  onUpdateEmail,
  onSendPasswordRecovery,
  onBackToLogin,
}: Props) => {
  return (
    <View style={{ maxWidth: 400 }}>
      <Card
        style={{
          width: '100%',
          maxWidth: 400,
        }}
      >
        <View
          style={{
            flex: 1,
            padding: 20,
          }}
        >
          <P1 style={{ textAlign: 'center', marginBottom: 16 }}>
            {t('web.login.forgotPasswordCard.passwordRecovery')}
          </P1>
          <P2 style={{ marginBottom: 16 }}>{t('web.login.forgotPasswordCard.enterEmail')}</P2>
          <FormInput
            type={'email'}
            placeholder={t('forgotPassword.emailTitle')}
            style={{ marginBottom: '16px' }}
            onChange={e => onUpdateEmail(e.currentTarget.value)}
          ></FormInput>
          <PrimaryButton
            onClick={onSendPasswordRecovery}
            title={t('forgotPassword.send')}
            style={{ width: '100%' }}
            enabled={isEnabled}
            loading={isLoading}
          />
        </View>
      </Card>
      <TertiaryButton
        onClick={onBackToLogin}
        style={{ width: '100%', marginTop: 16, textDecoration: 'underline' }}
      >
        {t('web.login.forgotPasswordCard.backToLogin')}
      </TertiaryButton>
    </View>
  );
};
